import { render } from "./questionmodel.vue?vue&type=template&id=3aa86ac7"
import script from "./questionmodel.vue?vue&type=script&lang=js"
export * from "./questionmodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__